import { styled } from '@linaria/react';

const Text = styled.i`
  font-style: italic;
  color: #515c69;
  font-weight: 400;
  font-size: 24px;
`;

type RankSymbolProps = {
  index: number;
  isShowIndex?: boolean;
};

const RankSymbol = ({ index, isShowIndex = false }: RankSymbolProps) => {
  const symbols = ['🥇', '🥈', '🥉'];
  return index < 3 ? symbols[index] : isShowIndex ? <Text>{index + 1}.</Text> : '';
};

export default RankSymbol;
